/* istanbul ignore file */

export const SITE_ACTIVITY_LOG_CONSTANTS = {
    ROW_HAS_BEEN_DELETED: 'Row has been deleted',
    ROW_HAS_NO_IDENTIFIER: 'No value',
    ROW_ID_AT_TIME_OF_CHANGE_TOOLTIP: 'Row ID at time of change'
};
